type Props = {
	children: React.ReactNode
}

export function AuthPageLayout({ children }: Props) {
	return (
		<div className="fixed inset-0 overflow-y-auto bg-primary-color rounded-xl flex flex-col items-center py-5 md:static md:min-h-screen">
			<img
				className="h-32 md:h-44"
				src="/logo_floatbridge_green.svg"
				alt="floatbridge logo"
			/>
			{children}
		</div>
	)
}